var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mu-container',{staticClass:"px-0",attrs:{"fluid":""}},[_c('mu-row',[_c('lang-menu'),_vm._v(" "),_c('navbar-desktop',{staticClass:"navbar-desktop-menu"}),_vm._v(" "),_c('navbar-mobile',{staticClass:"navbar-mobile-menu"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }